import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, numberToWords, rootUrl, sumOfArray } from "../helpers";
import { useAuth } from "../context/auth-context";
import axios from "axios";
import { toast } from "react-toastify";

const PaymentVoucher = React.forwardRef(({ data }, ref) => {
  
  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();
  const [showSignatureLine, setShowSignatureLine] = useState(true);
  const [voucherData, setVoucherData] = useState({
    preparedBy: {},
    checkedBy: {},
    authorisedBy: {},
    approvedBy: {},
    auditedBy: {},
    receivedBy: {},
    budgetDetails: [],
  });

  const {
    commitmentRefNo,
    cheque,
    voucher,
    paye,
    batchNo = "",
    journalNo = "",
    bSheetNo = "",
    date,
    purchaseOrderNo = "",
    chequeNumber = "",
    description,
    invoiceNumber = description?.split(':')[0]?.split('-')[1]?.trim(),
    amount,
    bank = "",
    accountNo = "",
    updatedBy,
  } = data;


  const [allneeded, setAllneeded] = useState([])

  const wrapText = (text = "", maxLen = 90) => {
    const s = String(text ?? "").trim();
    if (!s) return [];
    const words = s.split(/\s+/);
    const lines = [];
    let line = "";
    for (const w of words) {
      const next = line ? `${line} ${w}` : w;
      if (next.length <= maxLen) {
        line = next;
      } else {
        if (line) lines.push(line);
        line = w;
      }
    }
    if (line) lines.push(line);
    return lines;
  };

  const getSupData = async () => {

      try{
        const response = await axios.post(rootUrl(`/getInvoice`), {
          voucher:voucher,
          sid:paye
        });
       
        setAllneeded(response.data.data)
        
      }catch(e){
        toast.error(e?.message)
      }
  }
  
  
  const getOtherDetails = async () => {
    try {
      const response = await axios.get(rootUrl(`/getDetails/${data.id}`));
      const { other, cashApproval, cashAudit } = response.data;
      const cap = cashApproval || [];
      const audits = cashAudit || [];
      const latestAudit = audits.length > 0 ? audits[audits.length - 1] : null;
      const user = allData.users?.find((a) => a.u_id == updatedBy);
      const preparerName = `${user?.firstname || ""} ${user?.lastname || ""}`;

      const signerAtHierarchy = (h) => {
        const row = cap.find((c) => Number(c.hierarchy) === h);
        if (!row) {
          return { name: "", signature: "", date: "", designation: "" };
        }
        const dt = row.created_at || row.date;
        return {
          name: `${row.firstname || ""} ${row.lastname || ""}`.trim(),
          // signature: "",
          date: dt ? formatDate(String(dt).substring(0, 10)) : "",
          designation: row.position || "",
        };
      };

      setVoucherData({
        preparedBy: {
          name: preparerName,
          // signature: "",
          date: formatDate(date),
          designation: user?.position || "",
        },
        checkedBy: signerAtHierarchy(0),
        authorisedBy: signerAtHierarchy(1),
        approvedBy: signerAtHierarchy(2),
        auditedBy: latestAudit ? {
          isAudited: true,
          name: `${latestAudit.firstname || ""} ${latestAudit.lastname || ""}`.trim(),
          date: latestAudit.created_at ? formatDate(String(latestAudit.created_at).substring(0, 10)) : "",
        } : {
          isAudited: false,
          name: "",
          date: "",
        },
        receivedBy: {
          name: other?.receivedByName || "",
          address: other?.address || "",
          // signature: "",
          nrc: other?.nrc || "",
          date: other?.date || "",
          contactNo: other?.contactNo || "",
        },
        budgetDetails: allData.budget?.filter(
          (budget) => budget.id == data.coa_id
        ),
      });
    } catch (error) {
      console.error("Error fetching additional details:", error);
    }
  };

  useEffect(() => {
    getOtherDetails();
    getSupData();
  }, []);

  
  

  const renderBudgetDetails = () => {
    return (
      <table className="mt-1 border-collapse w-full text-[11px]">
        <tbody>
        <tr>
              <td colSpan={6} className="border border-gray-700 p-1">
                ACCOUNT NAME: <strong>{allData.bank.find(a=>a.id === bank)?.name}</strong>
              </td>
              <td colSpan={4} className="border border-gray-700 p-1">
                ACCOUNT NO: <strong>{allData.bank.find(a=>a.id === bank)?.account_no}</strong>
              </td>
            </tr>
            <tr>
              <th colSpan={10} className="border border-gray-700 text-center p-1 text-[12px]">
                BUDGET ALLOCATION DETAILS
              </th>
            </tr>
            <tr>
              {['Head', 'Dept', 'Unit', 'Programme', 'Sub-Programme', 'Commitment Item', 'Item-Name', 'Account Code', 'K'].map((header) => (
                <th key={header} className="border border-gray-700 p-1 text-left text-[11px]">
                  {header}
                </th>
              ))}
            </tr>
          {allneeded.filter(a=>a.type == 'expense').map((row, index) => {
            const bItems = allData.budget?.filter(
              (budget) => budget.id == row.coa_id
            )[0]
            return(
              <tr key={index} className="text-center">
              <td className="border border-gray-700 p-1">{auth.user.cid}</td>
              <td className="border border-gray-700 p-1">{allData.dept.find(a=>a.id === bItems?.dept)?.name || "Finance"}</td>
              <td className="border border-gray-700 p-1">{bItems?.unit}</td>
              <td className="border border-gray-700 p-1">
                {allData.program?.find(
                  (a) => a.programCode === bItems?.program
                )?.name || ""}
              </td>
              <td className="border border-gray-700 p-1">
                {allData.subProgram?.find(
                  (a) => parseInt(a.subProgramCode) === parseInt(bItems?.subprogram) && parseFloat(a.programCode) === parseFloat(bItems.program)
                )?.name || ""}
              </td>
              <td className="border border-gray-700 p-1"></td>
              <td className="border border-gray-700 p-1">{allData.coa.find(a=>a.account == bItems?.coa)?.name || ""}</td>
              <td className="border border-gray-700 p-1">{bItems?.coa || ""}</td>
              <td className="border border-gray-700 p-1">
                {formatToZMW(row?.amount)}
              </td>
              
            </tr>
            )
          })}

          <tr>
            <th className="border border-gray-700 p-1" colSpan={8}>
              Total
            </th>
            <th className="border border-gray-700 p-1 text-center">
              {formatToZMW(sumOfArray(allneeded.filter(a=>a.type == 'expense').map(res=>parseFloat(res?.amount))))}
            </th>
          </tr>
        </tbody>
      </table>
    );
  };

  const renderSignerSection = (title, signer) => (
    <div className="border border-gray-700 p-1 text-sm">
      
      <p className="font-semibold text-sm">{title}</p>
      <p className="text-sm">Name: {signer?.name || ''}</p>
      <p className="text-sm">Date: {signer?.date || ''}</p>
      <p className="text-sm">Designation: {signer?.designation || ''}</p>
      {showSignatureLine && (
        <div className="text-sm mt-1 flex items-center gap-2">
          <span>Signature:</span>
          <span className="flex-1 border-b border-gray-700 min-h-[14px]"></span>
        </div>
      )}
    </div>
  );

  return (
    <div
      ref={ref}
      className="text-[12px] leading-snug"
    >
      <style>{`@media print { .pv-signature-toggle { display: none !important; } }`}</style>
      <div
        className="pv-signature-toggle mb-2 flex justify-end"
        data-html2canvas-ignore="true"
      >
        <label className="inline-flex items-center gap-2 text-xs text-gray-700 bg-gray-50 border border-gray-200 rounded px-2 py-1">
          <input
            type="checkbox"
            checked={showSignatureLine}
            onChange={(e) => setShowSignatureLine(e.target.checked)}
          />
          Show signature line
        </label>
      </div>

{/* Header Section */}
<table className="w-full">
          <tbody>
            <tr>
              <td className="border-none">
              <img src="arms.png" className="w-[110px] h-[110px]" alt="Logo" />
              </td>
              <td className="border-none text-center" colSpan={6}>
                <h3 className=" font-bold">
                  <span className="text-lg">REPUBLIC OF ZAMBIA</span> <br />
                  <span className="text-base">MINISTRY OF LOCAL GOVERNMENT</span>
                  <br />
                  <span className="text-base">{allData.council[0]?.name.toUpperCase()}</span>
                </h3>
                <u className="text-base font-bold">PAYMENT VOUCHER</u>
              </td>
              <td className="border-none">
              <img className="w-[110px] h-[110px]" src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
              {voucherData?.auditedBy?.isAudited && (
                <div className="mt-1 text-right">
                  <p className="text-red-700 font-bold text-base">AUDITED</p>
                  <p className="text-red-700 text-[11px]">{voucherData.auditedBy.name}</p>
                  <p className="text-red-700 text-[10px]">{voucherData.auditedBy.date}</p>
                </div>
              )}
              </td>
            </tr>
          </tbody>
        </table>


      {/* Payment Details Section */}

      <div className="grid grid-cols-2 gap-2 items-center">
        <div>
        <p className="text-sm"><strong>COMMITMENT REF NO:</strong> {commitmentRefNo}</p>
        <p className="text-sm"><strong>PAYMENT VOUCHER NO:</strong> {voucher}</p>
        </div>

        <div>
        <h2 className="text-center font-bold text-sm">BATCH HEADER DETAILS</h2>
      {/* Batch Number */}
      <div className="flex">
        <span className="font-semibold text-sm w-24">BATCH NO.</span>
        <span className="border-b border-black flex-1 text-sm">{data.batchNo}</span>
      </div>
        </div>
      </div>
    
        <div className="mt-1 flex gap-3 items-center">
        <div className="w-[40%]">
            <p className="border border-gray-400 text-sm font-semibold p-2 pb-[15%]">
              <strong>PAYEE:</strong> 
              <br />  
              {allData.suppliers?.find((a) => a.id == paye)?.name || allData.bank?.find((a) => a.id == allneeded.find(a=>a.type == 'income')?.bank)?.name}
            </p>
          </div>
  
  
          <div className="w-[60%]">
          <div className="max-w-2xl mx-auto  bg-white">
      

      <div className="border border-gray-400 p-1">

      {/* Journal No. & B/Sheet No. */}
         
         <div className="flex w-full">
         <div className="w-1/2 items-center">
        <span className="font-semibold text-sm w-1/4">JOURNAL NO.:</span>
        <div className="flex space-x-0.5">
        {["","","",""].map((char, index) => (
        <div
          key={index}
          className="w-2.5 h-2.5 border border-black flex items-center justify-center text-xs p-1"
        >
          {char}
        </div>
      ))}

        </div>
      </div>
  
      <div className="w-1/2 items-center">
        <span className="font-semibold text-sm w-1/4">B/SHEET NO.:</span>
        <div className="flex space-x-0.5">
        {["","",""].map((char, index) => (
        <div
          key={index}
          className="w-2.5 h-2.5 border border-black flex items-center justify-center text-xs  p-1"
        >
          {char}
        </div>
      ))}

        </div>
      </div>
      </div>

      {/* Other Details */}
      <div className=" flex items-center">
        <span className="font-semibold text-sm w-[40%] w-1/4">Date:</span>
        <div className="flex space-x-0.5 mt-0.5">
        {`${date.substring(8,10)}/${date.substring(5,7)}/${date.substring(0,4)}`?.split("").map((char, index) => (
  <div
    key={index}
    className="w-3 h-3 border border-black flex items-center justify-center text-xs p-1.5"
  >
    {char}
  </div>
))}

        </div>
      </div>

      <div className=" flex items-center">
        <span className="font-semibold text-sm w-[40%] w-1/4">Purchase Order No:</span>
        <span className="border-b border-black ml-1 px-10 text-sm">{purchaseOrderNo}</span>
      </div>

      <div className=" flex items-center">
        <span className="font-semibold text-sm w-[40%] w-1/4">Invoice Number:</span>
        <span className={`border-b border-black ml-1 text-sm ${invoiceNumber == '' || invoiceNumber == undefined?'px-10':''}`}>{invoiceNumber}</span>
      </div>

      {/* Cheque/EFTA Number */}
      <div className="flex items-center">
        <span className="font-semibold text-sm w-[40%]">Cheque/EFTA Number:</span>
        <div className="flex space-x-0.5 mt-0.5">
          {cheque?.split("").map((char, index) => (
            <div
              key={index}
              className="w-3 h-3 border border-black flex items-center justify-center text-xs p-1.5"
            >
              {char}
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
          </div>
        </div>
      
        
       

     {/* Description Section */}
        <div className="mt-1">
          <p className="text-sm"><strong>DESCRIPTION OF PAYMENT</strong></p>
          <div className="h-12 border-t border-b border-gray-700 px-1 py-1 text-sm leading-tight overflow-hidden">
            {(() => {
              const lines = wrapText(description, 95);
              const l1 = lines[0] || "";
              const l2 = lines[1] || "";
              const hasMore = lines.length > 2;
              return (
                <div className="flex flex-col justify-center h-full">
                  <div className="truncate">{l1}</div>
                  <div className="truncate">{hasMore ? `${l2}…` : l2}</div>
                </div>
              );
            })()}
          </div>
          
          <p className="mt-1 text-sm"><strong>AMOUNT IN WORDS</strong></p>
          <div className="h-7 border-t border-b border-gray-700 p-1 text-sm">
          {numberToWords(sumOfArray(allneeded.filter(a=>a.type == 'expense').map(res=>parseFloat(res.amount))))} Kwacha
          </div>
        </div>

    

    


      {renderBudgetDetails()}
      {/* Signatures */}
      <div className="grid grid-cols-2 gap-3 mb-1 mt-1">
        {renderSignerSection("PREPARED BY", voucherData.preparedBy)}
        {renderSignerSection("CHECKED BY", voucherData.checkedBy)}
        {renderSignerSection("AUTHORISED BY", voucherData.authorisedBy)}
        {renderSignerSection("APPROVED BY", voucherData.approvedBy)}
      </div>

      {/* Received By */}
      <div className="border border-gray-700 p-1">
      <p className="font-semibold text-sm">RECEIVED BY</p>
        <div className="grid grid-cols-2 gap-2">

        <div>
        <p className="text-sm">Name: {voucherData.receivedBy.name}</p>
        <p className="text-sm">Address: {voucherData.receivedBy.address}</p>
        <p className="text-sm">Signature: {voucherData.receivedBy.signature}</p>
        </div>

        <div> 
        <p className="text-sm">NRC No.: {voucherData.receivedBy.nrc}</p>
        <p className="text-sm">Date.: {voucherData.receivedBy.date}</p>
        <p className="text-sm">Contact No.: {voucherData.receivedBy.contactNo}</p>
        </div>
        
       
      </div>
      </div>

      <p className="text-[11px] mt-1">NOTE: EFTA = ELECTRONIC FUNDS TRANSFER ADVICE</p>
    </div>
  );
});

export default PaymentVoucher;
